










































import Vue from 'vue'
import { oneOf } from '@/utils/helper'
import { Branch } from '@/entities/Album'
import CommonArrow from '@/components/shared/atoms/Icon/CommonArrow'
import SectionHeader from '@/components/shared/atoms/ContentParts/SectionHeader'
import FetchAlbumPhotosUseCase from '@/usecases/album/FetchAlbumPhotosUseCase'
import FetchOrderItemsByPhotosUseCase from '@/usecases/orderItem/FetchOrderItemsByPhotosUseCase'
import PhotoEntity from '@/entities/Photo'

export default Vue.extend({
  name: 'EventAlbumList',
  components: {
    SectionHeader,
    CommonArrow
  },
  props: {
    branch: {
      type: Object as () => Branch,
      required: true
    },
    eventId: {
      type: Number,
      required: true
    },
    uchinokoPhotos: {
      type: Object as () => { [albumId: number]: { [photoId: number]: PhotoEntity } },
      required: true
    },
    mode: {
      type: String,
      default: 'default',
      validator: oneOf(['default', 'categoryMenu'])
    },
    currentAlbumId: {
      type: Number,
      default: null
    },
    isUchinokoSearchEnabled: {
      type: Boolean,
      default: () => false
    },
    isFaceSearchExtra: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    photosPath(): string {
      return `/events/${this.eventId}/albums/${this.branch.data.props.id}/photos`
    },
    targetUchinokoPhotos(): PhotoEntity[] {
      const target = this.uchinokoPhotos[this.branch.data.props.id] || {}
      return Object.values(target)
    },
    isCurrentAlbum(): boolean {
      return this.branch.data.props.id === this.currentAlbumId
    }
  },
  methods: {
    block() {
      return false
    },
    handleClick() {
      this.$emit('click')
    },
    async faceJump(photoId: number, albumId: number) {
      const usecase = new FetchAlbumPhotosUseCase({
        snapsnapGateway: this.$snapsnapGateway,
        eventRepository: this.$eventRepository,
        pagerRepository: this.$pagerRepository,
        fetchOrderItemsByPhotosUseCase: new FetchOrderItemsByPhotosUseCase({
          snapsnapGateway: this.$snapsnapGateway,
          orderItemRepository: this.$orderItemRepository
        })
      })
      try {
        const { page } = await usecase.execute({ eventId: this.eventId, albumId, include: photoId })
        this.$router.push({ name: 'events-eventId-albums-albumId-photos', query: { page: String(page), photoId: String(photoId) }, params: { albumId: String(albumId), faceJumpStatus: 'true' } })
      } catch (e) {
        throw new Error(e)
      }
    }
  }
})
